import _extends from "@babel/runtime/helpers/extends";
import { formilyCore } from '@alife/cn-ui';
import { isEmpty, find, isNil, isString, isPlainObject } from 'lodash-es';
import { getRequest, request } from 'cn-request';
import { FORMILY_HOOKS, CONDITION_OPTIONS, ALL_FIELDS_KEY, RequestParamsMap, OperatorMap } from "../const";
export var isFormHooks = function isFormHooks(value) {
  var _find;
  return !isNil(find((_find = find(FORMILY_HOOKS, 'isFormHooks')) === null || _find === void 0 ? void 0 : _find.children, ['value', value]));
};
export var isNoValueCondition = function isNoValueCondition(value) {
  var _find$hiddenValue, _find2;
  return (_find$hiddenValue = (_find2 = find(CONDITION_OPTIONS, ['value', value])) === null || _find2 === void 0 ? void 0 : _find2.hiddenValue) !== null && _find$hiddenValue !== void 0 ? _find$hiddenValue : false;
};
var packRequest = function packRequest(options) {
  if (!getRequest()) {
    console.error('组件使用默认实例中...请先初始化项目cn-request,切勿发布到生产环境');
  }
  return request(options).then(function (result) {
    if ('request' in result && 'config' in result) {
      return result.data;
    }
    return result;
  });
};
var generateParams = function generateParams(array, config) {
  if (config === void 0) {
    config = {};
  }
  var _config = config,
    form = _config.form,
    _config$state = _config.state,
    state = _config$state === void 0 ? {} : _config$state,
    _config$fieldValue = _config.fieldValue,
    fieldValue = _config$fieldValue === void 0 ? '' : _config$fieldValue;
  return Array.from(array).reduce(function (acc, _ref) {
    var key = _ref.key,
      value = _ref.value;
    console.log('value', value);
    // 兼容已接入的业务逻辑，通过value类型进行判断
    if (isString(value)) {
      var _Object$assign;
      return Object.assign(acc, (_Object$assign = {}, _Object$assign[key] = value === '$self.value' ? fieldValue : value, _Object$assign));
    }

    // 新结构，value格式为对象
    if (isPlainObject(value)) {
      var _Object$assign2;
      var paramType = value.paramType,
        content = value.content;
      var finalContent;
      if (paramType === 'FORM') {
        var _form$getState$values;
        finalContent = form === null || form === void 0 ? void 0 : (_form$getState$values = form.getState().values) === null || _form$getState$values === void 0 ? void 0 : _form$getState$values[content];
      }
      if (paramType === 'URLPARAM') {
        var _state$RequestParamsM, _RequestParamsMap$URL;
        finalContent = state === null || state === void 0 ? void 0 : (_state$RequestParamsM = state[(_RequestParamsMap$URL = RequestParamsMap['URLPARAM']) === null || _RequestParamsMap$URL === void 0 ? void 0 : _RequestParamsMap$URL.param]) === null || _state$RequestParamsM === void 0 ? void 0 : _state$RequestParamsM[content];
      }
      if (paramType === 'STATICSTRING') {
        finalContent = content;
      }
      if (paramType === 'JSEXPN') {
        var jsFun = new Function("return " + content)();
        finalContent = jsFun(form === null || form === void 0 ? void 0 : form.getState().values, state);
      }
      return Object.assign(acc, (_Object$assign2 = {}, _Object$assign2[key] = finalContent, _Object$assign2));
    }
    return acc;
  }, {});
};
export var handleRequestService = function handleRequestService(requestConfig) {
  var _ref2 = requestConfig || {},
    url = _ref2.url,
    service = _ref2.service,
    paramsProps = _ref2.params,
    dataProps = _ref2.data,
    _ref2$searchFormat = _ref2.searchFormat,
    searchFormat = _ref2$searchFormat === void 0 ? function (data) {
      return data;
    } : _ref2$searchFormat,
    _ref2$method = _ref2.method,
    method = _ref2$method === void 0 ? 'GET' : _ref2$method;
  if (service) {
    return service;
  }
  if (url) {
    return function (searchConfig) {
      var _ref3 = searchConfig || {},
        formValues = _ref3.formValues;
      var params = (method === null || method === void 0 ? void 0 : method.toLocaleUpperCase()) === 'GET' ? searchFormat(_extends({}, formValues, paramsProps)) : paramsProps;
      var data = (method === null || method === void 0 ? void 0 : method.toLocaleUpperCase()) === 'POST' ? searchFormat(_extends({}, formValues, dataProps)) : dataProps;
      return packRequest(_extends({}, requestConfig, {
        params: params,
        data: data,
        url: url
      }));
    };
  }
  return function () {
    return Promise.resolve([]);
  };
};
var getRealCondition = function getRealCondition(condition, conditionValue) {
  return "" + condition.replace('${conditionValue}', "'" + conditionValue + "'");
};

// 多对一条件的新方法
export var generateEffects = function generateEffects(reactionsList, config) {
  if (config === void 0) {
    config = {};
  }
  var _config2 = config,
    state = _config2.state;
  reactionsList.forEach(function (watchItem) {
    var watchCode = watchItem.watchCode,
      reactions = watchItem.reactions;
    reactions.forEach(function (reaction) {
      var effects = reaction.effects,
        fulfill = reaction.fulfill;
      var resourcePool = fulfill.resourcePool,
        logic = fulfill.logic;
      var rpField = resourcePool.field,
        rpState = resourcePool.state,
        rpCondition = resourcePool.condition,
        rpConditionValue = resourcePool.conditionValue,
        _resourcePool$data = resourcePool.data,
        rpData = _resourcePool$data === void 0 ? {} : _resourcePool$data;
      var fromDataSource = rpData.fromDataSource,
        syncData = rpData.syncData,
        asyncData = rpData.asyncData;
      var requestConfig = {
        url: asyncData === null || asyncData === void 0 ? void 0 : asyncData.url,
        method: asyncData === null || asyncData === void 0 ? void 0 : asyncData.method,
        formatResult: asyncData !== null && asyncData !== void 0 && asyncData.formatResult ? new Function("return " + asyncData.formatResult)() : function (res) {
          return res;
        }
      };
      var fieldEffectsHandle;

      // 通过logic区分新旧Schema
      if (isNil(logic)) {
        fieldEffectsHandle = function fieldEffectsHandle(field, form) {
          // 监听onFieldChange时，会存在field.value为undefined的情况；需要做容错处理
          field.value = field.value ? field.value : '';

          // new Function("$self", "$form", `${fulfill?.run}`)(field, form)

          var conditionResult = new Function('$self', "return " + getRealCondition(rpCondition, rpConditionValue))(field);
          if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.method.toLocaleUpperCase()) === 'GET') {
            var _asyncData$params;
            requestConfig.params = generateParams((_asyncData$params = asyncData.params) === null || _asyncData$params === void 0 ? void 0 : _asyncData$params.array, {
              fieldValue: field.value,
              form: form,
              state: state
            });
          }
          if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.method.toLocaleUpperCase()) === 'POST') {
            var _asyncData$params2;
            requestConfig.data = generateParams((_asyncData$params2 = asyncData.params) === null || _asyncData$params2 === void 0 ? void 0 : _asyncData$params2.array, {
              fieldValue: field.value,
              form: form,
              state: state
            });
          }
          if (rpState === 'value') {
            if (conditionResult) {
              var requestService = handleRequestService(requestConfig);
              requestService().then(function (requestRes) {
                var _find3;
                var currentOption = fromDataSource ? (_find3 = find(field.getState().dataSource, ['value', field.value])) !== null && _find3 !== void 0 ? _find3 : {} : {};
                var realResponseData = requestConfig.formatResult(requestRes);
                var finalData = Object.assign(currentOption, new Function("return " + syncData)(), realResponseData);
                rpField.forEach(function (f) {
                  if (f === ALL_FIELDS_KEY) {
                    form.setValues(_extends({}, finalData));
                  } else {
                    form.setFieldState(f, {
                      value: finalData === null || finalData === void 0 ? void 0 : finalData[f]
                    });
                  }
                });
              });
            } else {
              rpField.forEach(function (f) {
                form.setFieldState(f, {
                  value: ''
                });
              });
            }
          } else if (rpState === 'dataSource') {
            if (conditionResult) {
              var _find4;
              var currentOption = fromDataSource ? (_find4 = find(field.getState().dataSource, ['value', field.value])) !== null && _find4 !== void 0 ? _find4 : {} : {};
              var realSyncData = new Function("return " + syncData)();
              var finalData = Object.assign(currentOption);
              var _requestService = handleRequestService(requestConfig);
              _requestService().then(function (requestRes) {
                rpField.forEach(function (f) {
                  form.setFieldState(f, {
                    value: ''
                  });
                  form.setFieldState(f, function (state) {
                    if (Array.isArray(realSyncData)) {
                      var _Object$assign3;
                      Object.assign(finalData, (_Object$assign3 = {}, _Object$assign3[f] = realSyncData, _Object$assign3));
                    }
                    var realResponseData = requestConfig.formatResult(requestRes);
                    if (Array.isArray(realResponseData)) {
                      var _Object$assign4;
                      Object.assign(finalData, (_Object$assign4 = {}, _Object$assign4[f] = realResponseData, _Object$assign4));
                    }
                    state.dataSource = finalData === null || finalData === void 0 ? void 0 : finalData[f];
                  });
                });
              });
            } else {
              rpField.forEach(function (f) {
                form.setFieldState(f, function (state) {
                  state.dataSource = [];
                });
              });
            }
          } else if (rpState === 'none') {
            // 当display为none时，需要特殊处理，因为none不在Field模型内
            rpField.forEach(function (f) {
              form.setFieldState(f, function (state) {
                state.display = conditionResult ? 'none' : 'visible';
              });
            });
          } else {
            rpField.forEach(function (f) {
              form.setFieldState(f, function (state) {
                state[rpState] = conditionResult;
              });
            });
          }
        };
      } else {
        var getRealMulCondition = function getRealMulCondition(form) {
          var result = '';
          logic.forEach(function (singleLogic, index) {
            var _form$query;
            var operator = singleLogic.operator,
              watchCode = singleLogic.watchCode,
              condition = singleLogic.condition,
              conditionValue = singleLogic.conditionValue;
            var targetField = form === null || form === void 0 ? void 0 : (_form$query = form.query(watchCode)) === null || _form$query === void 0 ? void 0 : _form$query.take();
            var conditionResult = new Function('$self', "return " + getRealCondition(condition, conditionValue))(targetField);

            // index为0时，不需要处理operator；因为是逻辑中的第一个运算条件
            if (index === 0) {
              result += conditionResult;
            } else {
              var _OperatorMap$operator;
              result += "" + ((_OperatorMap$operator = OperatorMap === null || OperatorMap === void 0 ? void 0 : OperatorMap[operator]) !== null && _OperatorMap$operator !== void 0 ? _OperatorMap$operator : '&&') + conditionResult;
            }
          });
          return result;
        };
        fieldEffectsHandle = function fieldEffectsHandle(field, form) {
          // 监听onFieldChange时，会存在field.value为undefined的情况；需要做容错处理
          field.value = field.value ? field.value : '';
          var conditionResult = new Function("return " + getRealMulCondition(form))();
          if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.method.toLocaleUpperCase()) === 'GET') {
            var _asyncData$params3;
            requestConfig.params = generateParams((_asyncData$params3 = asyncData.params) === null || _asyncData$params3 === void 0 ? void 0 : _asyncData$params3.array, {
              fieldValue: field.value,
              form: form,
              state: state
            });
          }
          if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.method.toLocaleUpperCase()) === 'POST') {
            var _asyncData$params4;
            requestConfig.data = generateParams((_asyncData$params4 = asyncData.params) === null || _asyncData$params4 === void 0 ? void 0 : _asyncData$params4.array, {
              fieldValue: field.value,
              form: form,
              state: state
            });
          }
          if (rpState === 'value') {
            if (conditionResult) {
              var requestService = handleRequestService(requestConfig);
              requestService().then(function (requestRes) {
                var _find5;
                var currentOption = fromDataSource ? (_find5 = find(field.getState().dataSource, ['value', field.value])) !== null && _find5 !== void 0 ? _find5 : {} : {};
                var realResponseData = requestConfig.formatResult(requestRes);
                var finalData = Object.assign(currentOption, new Function("return " + syncData)(), realResponseData);
                rpField.forEach(function (f) {
                  if (f === ALL_FIELDS_KEY) {
                    form.setValues(_extends({}, finalData));
                  } else {
                    form.setFieldState(f, {
                      value: finalData === null || finalData === void 0 ? void 0 : finalData[f]
                    });
                  }
                });
              });
            } else {
              rpField.forEach(function (f) {
                form.setFieldState(f, {
                  value: ''
                });
              });
            }
          } else if (rpState === 'dataSource') {
            if (conditionResult) {
              var _find6;
              var currentOption = fromDataSource ? (_find6 = find(field.getState().dataSource, ['value', field.value])) !== null && _find6 !== void 0 ? _find6 : {} : {};
              var realSyncData = new Function("return " + syncData)();
              var finalData = Object.assign(currentOption);
              var _requestService2 = handleRequestService(requestConfig);
              _requestService2().then(function (requestRes) {
                rpField.forEach(function (f) {
                  form.setFieldState(f, {
                    value: ''
                  });
                  form.setFieldState(f, function (state) {
                    if (Array.isArray(realSyncData)) {
                      var _Object$assign5;
                      Object.assign(finalData, (_Object$assign5 = {}, _Object$assign5[f] = realSyncData, _Object$assign5));
                    }
                    var realResponseData = requestConfig.formatResult(requestRes);
                    if (Array.isArray(realResponseData)) {
                      var _Object$assign6;
                      Object.assign(finalData, (_Object$assign6 = {}, _Object$assign6[f] = realResponseData, _Object$assign6));
                    }
                    state.dataSource = finalData === null || finalData === void 0 ? void 0 : finalData[f];
                  });
                });
              });
            } else {
              rpField.forEach(function (f) {
                form.setFieldState(f, function (state) {
                  state.dataSource = [];
                });
              });
            }
          } else if (rpState === 'none') {
            // 当display为none时，需要特殊处理，因为none不在Field模型内
            rpField.forEach(function (f) {
              form.setFieldState(f, function (state) {
                state.display = conditionResult ? 'none' : 'visible';
              });
            });
          } else {
            rpField.forEach(function (f) {
              form.setFieldState(f, function (state) {
                state[rpState] = conditionResult;
              });
            });
          }
        };
      }
      var formEffectsHandle = function formEffectsHandle(form) {
        if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.method.toLocaleUpperCase()) === 'GET') {
          var _asyncData$params5;
          requestConfig.params = generateParams((_asyncData$params5 = asyncData.params) === null || _asyncData$params5 === void 0 ? void 0 : _asyncData$params5.array, {
            form: form,
            state: state
          });
        }
        if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.method.toLocaleUpperCase()) === 'POST') {
          var _asyncData$params6;
          requestConfig.data = generateParams((_asyncData$params6 = asyncData.params) === null || _asyncData$params6 === void 0 ? void 0 : _asyncData$params6.array, {
            form: form,
            state: state
          });
        }
        if (['initialValue', 'value'].includes(rpState)) {
          var requestService = handleRequestService(requestConfig);
          requestService().then(function (requestRes) {
            var realResponseData = requestConfig.formatResult(requestRes);
            var finalData = Object.assign({}, new Function("return " + syncData)(), realResponseData);
            if (rpState === 'initialValue') {
              rpField.forEach(function (f) {
                if (f === ALL_FIELDS_KEY) {
                  form.setInitialValues(_extends({}, finalData));
                } else {
                  form.setFieldState(f, function (state) {
                    state.initialValue = finalData === null || finalData === void 0 ? void 0 : finalData[f];
                  });
                }
              });
            }
            if (rpState === 'value') {
              rpField.forEach(function (f) {
                if (f === ALL_FIELDS_KEY) {
                  form.setValues(_extends({}, finalData));
                } else {
                  form.setFieldState(f, function (state) {
                    state.value = finalData === null || finalData === void 0 ? void 0 : finalData[f];
                  });
                }
              });
            }
          });
        } else if (rpState === 'dataSource') {
          var realSyncData = new Function("return " + syncData)();
          var finalData = {};
          var _requestService3 = handleRequestService(requestConfig);
          _requestService3().then(function (requestRes) {
            rpField.forEach(function (f) {
              // 此处需要使用*(${f})写法，否则当触发CnDynamicForm中clearFormGraph、deleteValuesIn方法时，dataSource会被清空。
              form.setFieldState("*(" + f + ")", function (state) {
                if (Array.isArray(realSyncData)) {
                  var _Object$assign7;
                  Object.assign(finalData, (_Object$assign7 = {}, _Object$assign7[f] = realSyncData, _Object$assign7));
                }
                var realResponseData = requestConfig.formatResult(requestRes);
                if (Array.isArray(realResponseData)) {
                  var _Object$assign8;
                  Object.assign(finalData, (_Object$assign8 = {}, _Object$assign8[f] = realResponseData, _Object$assign8));
                }
                state.dataSource = finalData === null || finalData === void 0 ? void 0 : finalData[f];
              });
            });
          });
        } else if (rpState === 'none') {
          // 当display为none时，需要特殊处理，因为none不在Field模型内
          rpField.forEach(function (f) {
            form.setFieldState(f, function (state) {
              state.display = 'none';
            });
          });
        } else {
          rpField.forEach(function (f) {
            form.setFieldState(f, function (state) {
              state[rpState] = true;
            });
          });
        }

        // else {
        //   rpField.forEach(f => {
        //     form.setFieldState(f, (state) => {
        //       state[rpState] = true;
        //     });
        //   });
        // }
      };

      // 判断当存在watchCode并且存在fulfill.run时，才执行
      if (!isEmpty(resourcePool)) {
        if (isFormHooks(effects[0])) {
          var _formilyCore$effects$;
          (_formilyCore$effects$ = formilyCore[effects[0]]) === null || _formilyCore$effects$ === void 0 ? void 0 : _formilyCore$effects$.call(formilyCore, formEffectsHandle);
        } else {
          if (effects[0].includes('_')) {
            var _formilyCore$effectsH;
            var _effects$0$split = effects[0].split('_'),
              effectsHook = _effects$0$split[0],
              effectsWatch = _effects$0$split[1],
              watchBool = _effects$0$split[2];
            var execuBool = new Function("return " + watchBool)();
            (_formilyCore$effectsH = formilyCore[effectsHook]) === null || _formilyCore$effectsH === void 0 ? void 0 : _formilyCore$effectsH.call(formilyCore, watchCode, [effectsWatch], function (field, form) {
              if (field.getState()[effectsWatch] === execuBool) {
                fieldEffectsHandle(field, form);
              }
            });
          } else {
            var _formilyCore$effects$2;
            (_formilyCore$effects$2 = formilyCore[effects[0]]) === null || _formilyCore$effects$2 === void 0 ? void 0 : _formilyCore$effects$2.call(formilyCore, watchCode, fieldEffectsHandle);
          }
        }
      }
    });
  });
};